<script lang="ts">
    import {email, page} from "./data";
    import AdminPage from "./pages/AdminPage.svelte";
    import EnterCodePage from "./pages/EnterCodePage.svelte";
    import EnterEmailPage from "./pages/EnterEmailPage.svelte";
    import RegistrationPage from "./pages/RegistrationPage.svelte";
</script>

<header>
    <nav>
        <ul>
            <li><strong>WOB Registration Page</strong></li>
        </ul>
        {#if $page === 'Registration'}
            <li>{$email}</li>
            <li on:click={() => {$email = ''; page.set('EnterEmail')}}><a href="/logout">logout</a></li>
        {/if}
    </nav>
</header>

<main>
    <div class="container">
    {#if $page === 'Admin'}
        <AdminPage/>
    {:else if $page === 'EnterCode'}
        <EnterCodePage/>
    {:else if $page === 'EnterEmail'}
        <EnterEmailPage/>
    {:else if $page === 'Registration'}
        <RegistrationPage/>
    {/if}
    </div>
</main>

<footer style="padding-bottom: 2rem;">
    <small>© 2026 WOB Team & Forrest Milner.
        please contact woballsouls@gmail.com with any questions.
    </small>
</footer>

<style>
    header, footer {
        background-color: #cecece;
        padding-left: 2rem;
    }
    main {
        flex: 1;
    }
</style>